// extracted by mini-css-extract-plugin
export default {"root":"PhysCreatePromptModal_root__FH5Au","buttonGroup":"PhysCreatePromptModal_buttonGroup__HtZLF"};